import { NgModule } from '@angular/core';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { ViewPdfComponent } from './view-pdf/view-pdf.component';
import { FacturaComponent } from './factura/factura.component';
import { PrintComponent } from './print/print.component';
import { SharedModule } from '../shared.module';
import { DownloaderComponent } from './downloader/downloader.component';

@NgModule({
  declarations: [FileUploadComponent, ViewPdfComponent, FacturaComponent, PrintComponent, DownloaderComponent ],
  imports: [SharedModule],
  exports: [FileUploadComponent, ViewPdfComponent, FacturaComponent, PrintComponent, DownloaderComponent ]
})
export class ComponentsModule {}
